import gql from 'graphql-tag';

export const CommonDateFields = gql`
  fragment CommonDateFields on OdProtosCommon_Date {
    year
    month
    day
  }
`;
